
export const CALCULATED_SORT_ORDER = {
  SCORE_TOTAL: 'scoreTotal',
  SCORE_STROKE: 'scoreStroke',
  SCORE_OPEN: 'scoreOpen',
  SCORE_FORCE: 'scoreForce',
  SUGGESTION_PATTERN: 'suggestionPattern',
} as const;

export type CalculatedSortOrder = typeof CALCULATED_SORT_ORDER[keyof typeof CALCULATED_SORT_ORDER];

export const CALCULATED_SORT_ORDER_LABEL = {
  [CALCULATED_SORT_ORDER.SCORE_TOTAL]: '総合評価値',
  [CALCULATED_SORT_ORDER.SCORE_STROKE]: 'ストローク',
  [CALCULATED_SORT_ORDER.SCORE_OPEN]: '把持幅',
  [CALCULATED_SORT_ORDER.SCORE_FORCE]: '把持力',
  [CALCULATED_SORT_ORDER.SUGGESTION_PATTERN]: 'ハンド型',
} as const;
